import vue from 'vue';
import Vuex from 'vuex';
vue.use(Vuex);
const store = new Vuex.Store(
    {
        state: {
            problem:{},
            params:'',//存放其他系统通过url传入的参数
        },
        getters:{
            getProblem:function(state){
                return state.problem;
            },
            getParams:function(state){
                return state.params;
            },

        },
        mutations: {
            setProblem:function(state,problem){
                state.problem = problem;
            },
            setParams:function(state,params){
                state.params = params;
            },
        },
        actions: {

        },
        module: {

        }
    }
)
export default store;


// WEBPACK FOOTER //
// ./src/vuex/index.js